import styled from 'styled-components';
import { getStyles } from '../../utils/getStyles/getStyles';
export const SnackbarStyled = styled.div `
  ${({ styles }) => getStyles(styles?.container)};
`;
export const ButtonWrapper = styled.div ``;
export const SnackbarIconTitleContainerWrapper = styled.div `
  ${({ styles }) => getStyles(styles?.iconTitleContainer)};
`;
export const SnackbarNoStatusContentWrapper = styled.div `
  ${({ styles, withIcon }) => withIcon &&
    `margin-left: calc(${styles?.icon?.width ?? '0rem'} + ${styles?.iconTitleContainer?.gap ?? '0rem'});`};
`;
export const SnackbarTextAndActionWrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
export const SnackbarTextWrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
export const SnackbarTitleWrapper = styled.div `
  display: flex;
  align-items: center;
`;
export const SnackbarLinkWrapper = styled.div `
  display: flex;
  ${({ styles, withIcon }) => withIcon &&
    `margin-left: calc(${styles?.icon?.width ?? '0rem'} + ${styles?.iconTitleContainer?.gap ?? '0rem'});`};
`;
export const SnackbarDescriptionWrapper = styled.div `
  display: flex;
`;
//# sourceMappingURL=snackbar.styled.js.map